import {
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TableBody,
  TextField,
  Typography,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { useFormik } from "formik";
import {
  REQUEST_DOCUMENT_STEP,
  RoleId,
  STATUS_PROCESS,
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getDefaultRow, getErrorMessage } from "libs/utils/form";
import { get, isError } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartForm,
  addSmartFormSlice,
  getSmartFormFieldConfig,
  selectSmartFormFieldConfig,
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepE() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subName = useSmartSubName();

  const theme = useTheme();
  const [isSaveDraft, setSaveDraft] = useState(false);

  const { showLoading, hideLoading } = useModalLoading();
  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, smartform, addSmartFormState, getSmartForm } =
    useSmartForm();
  const canEdit = useSelector(canEditForm);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const masterData = useSelector(selectMasterData);
  const startupSectorsConfig = get(masterData, "startupSectorsConfig", []);
  const activitiesConfig = get(masterData, "activitiesConfig", []);
  const startupStageConfig = get(masterData, "startupStageConfig", []);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const detailList = [
    "StartupName",
    "Slogan",
    "startupSecId",
    "activitiesId",
    "startupStageId",
    "BusinessOrActivityInThai",
    "BusniessOrProductDesc",
    "BusinessModelDesc",
    "MissionDesc",
    "Vision",
    "TargetMarket",
    "GrowthStrategy",
    "WhyisyourStartup",
    "organizationteam",
    "PleaseSpecify",
    "WhydidyourChoose",
    "PleaseExplain",
  ];
  const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
  const partfromId =
    defaultType.find((field) => field.partFromName === "Part E")?.partfromId ||
    "";
  const detail = get(smartform, "detail", [])
    .filter((field) => field.partfromId === partfromId)
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        startupSectorsConfig: true,
        ActivitiesConfig: true,
        startupStageConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartserviceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId }));
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState.error?.message,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    draftId,
    getSmartForm,
    hideLoading,
    isSaveDraft,
    personalId,
    smartserviceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const documentFields = Object.keys(values);
    const getFieldListConfig = defaultType
      .filter((field) => field.partfromId === partfromId)
      .filter((field) => documentFields.includes(field.smartName));

    const getValue = (field) => {
      switch (field.smartName) {
        case "organizationteam": {
          const organizationteam = get(values, field.smartName, []);
          const value = organizationteam.filter((v) => !!v.organizationName);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId,
      personalId: personalId,
      survey: null,
      visaissuance: null,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const defaultOrganizationteam = {
    organizationId: null,
    organizationName: "",
    organizationTitle: "",
    status: true,
  };
  const mapOrganizationteam = (value) => ({
    organizationId: value.organizationId,
    organizationName: value.organizationName,
    OrganizationTitle: value.organizationTitle,
    Status: value.status,
  });
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const validationSchema = yup.object({});
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      StartupName: get(detail, "StartupName.value", ""),
      Slogan: get(detail, "Slogan.value", ""),
      startupSecId: get(detail, "startupSecId.value", ""),
      activitiesId: get(detail, "activitiesId.value", ""),
      startupStageId: get(detail, "startupStageId.value", ""),
      BusinessOrActivityInThai: get(
        detail,
        "BusinessOrActivityInThai.value",
        ""
      ),
      BusniessOrProductDesc: get(detail, "BusniessOrProductDesc.value", ""),
      BusinessModelDesc: get(detail, "BusinessModelDesc.value", ""),
      MissionDesc: get(detail, "MissionDesc.value", ""),
      Vision: get(detail, "Vision.value", ""),
      TargetMarket: get(detail, "TargetMarket.value", ""),
      GrowthStrategy: get(detail, "GrowthStrategy.value", ""),
      WhyisyourStartup: get(detail, "WhyisyourStartup.value", ""),
      PleaseSpecify: get(detail, "PleaseSpecify.value", ""),
      WhydidyourChoose: get(detail, "WhydidyourChoose.value", ""),
      PleaseExplain: get(detail, "PleaseExplain.value", ""),
      organizationteam: getDefaultRow(
        detail,
        "organizationteam.value",
        defaultOrganizationteam
      ).map(mapOrganizationteam),
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });

  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  const configField1 = [
    {
      bagde: 4,
      label: "Business or activity plan in Thailand",
      fieldName: "BusinessOrActivityInThai",
    },
    {
      bagde: 5,
      label: "Business or products or services description",
      fieldName: "BusniessOrProductDesc",
    },
    {
      bagde: 6,
      label: "Business Model: Description of the idea and business model",
      fieldName: "BusinessModelDesc",
    },
    {
      bagde: 7,
      label: "Mission: Description of your organization's mission",
      fieldName: "MissionDesc",
    },
    {
      bagde: 8,
      label: "Vision: Description of your organization's vision",
      fieldName: "Vision",
    },
    {
      bagde: 9,
      label: "Target market: Description of your target customers or clients",
      fieldName: "TargetMarket",
    },
    {
      bagde: 10,
      label:
        "Growth Strategy: Please explain your growth objectives and how do you intend to develop your startup business",
      fieldName: "GrowthStrategy",
    },
    {
      bagde: 11,
      label: "Why is your startup innovative? Please explain",
      fieldName: "WhyisyourStartup",
    },
  ];

  const configField2 = [
    {
      bagde: 13,
      label:
        "Please specify your funding sources; a list of your funding sources that you already have or intend to apply for",
      fieldName: "PleaseSpecify",
    },
    {
      bagde: 14,
      label: "Why did you choose Thailand as your destination? Please explain",
      fieldName: "WhydidyourChoose",
    },
    {
      bagde: 15,
      label: "How would your business benefit Thailand? Please explain",
      fieldName: "PleaseExplain",
    },
  ];

  const Organizationteam = formik.values.organizationteam || [];

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “S” ${subName}`}
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={6}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part E : Business plan or activities in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div className={classes.wrapField}>
                      <InputLabel>Startup Name</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="StartupName"
                        value={formik.values.StartupName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("StartupName", formik)}
                        helperText={getErrorMessage("StartupName", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={3}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <InputLabel>Slogan (If any)</InputLabel>
                      <TextField
                        disabled={!canEdit}
                        variant="outlined"
                        className={classes.textField}
                        name="Slogan"
                        value={formik.values.Slogan}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("Slogan", formik)}
                        helperText={getErrorMessage("Slogan", formik)}
                      />
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              <TableRowHead>
                <StyledTableCell colSpan={6} align="start">
                  <div className={classes.cellContent}>
                    <Bagde number={3} />
                    <InputLabel>
                      Please choose the startup sectors/ targeted industries
                      /startup stage most relevant to your activities
                    </InputLabel>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Startup Sectors</InputLabel>
                </StyledTableCell>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel>Targeted Industries</InputLabel>
                </StyledTableCell>
                <StyledTableCell colSpan={2} align="center">
                  <InputLabel> Startup Stage</InputLabel>
                </StyledTableCell>
              </TableRowHead>

              <TableRow>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("startupSecId", formik)}
                        style={{ width: 300 }}
                      >
                        <InputLabel>Selected Startup Sectors</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected Startup Sectors"
                          name="startupSecId"
                          value={formik.values.startupSecId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {startupSectorsConfig.map((startupSectors) => (
                            <MenuItem
                              value={startupSectors.startupSecId}
                              key={startupSectors.startupSecId}
                            >
                              {startupSectors.startupSectorsName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={isError("startupSecId", formik)}>
                          {getErrorMessage("startupSecId", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("activitiesId", formik)}
                        style={{ width: 300 }}
                      >
                        <InputLabel>Selected Targeted Industries</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected Targeted Industries"
                          name="activitiesId"
                          value={formik.values.activitiesId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {activitiesConfig.map((activities) => (
                            <MenuItem
                              value={activities.activitiesId}
                              key={activities.activitiesId}
                            >
                              {activities.activitiesName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText error={isError("activitiesId", formik)}>
                          {getErrorMessage("activitiesId", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
                <StyledTableCell colSpan={2}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("startupStageId", formik)}
                        style={{ width: 300 }}
                      >
                        <InputLabel>Selected Startup Stage</InputLabel>
                        <Select
                          disabled={!canEdit}
                          label="Selected Startup Stage"
                          name="startupStageId"
                          value={formik.values.startupStageId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {startupStageConfig.map((startupStage) => (
                            <MenuItem
                              value={startupStage.startupStageId}
                              key={startupStage.startupStageId}
                            >
                              {startupStage.startupStageName}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText
                          error={isError("startupStageId", formik)}
                        >
                          {getErrorMessage("startupStageId", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>

              {configField1.map((field) => (
                <TableRow key={field.fieldName}>
                  <StyledTableCell colSpan={6}>
                    <div className={classes.cellContent}>
                      <Bagde number={field.bagde} />
                      <div className={classes.wrapField}>
                        <InputLabel>{field.label}</InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={field.fieldName}
                          value={formik.values[field.fieldName]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError(field.fieldName, formik)}
                          helperText={getErrorMessage(field.fieldName, formik)}
                          multiline
                          rows={5}
                          rowsMin={5}
                          rowsMax={5}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              ))}

              <TableRowHead>
                <StyledTableCell colSpan={6} align="start">
                  <div className={classes.cellContent}>
                    <Bagde number={12} />
                    <InputLabel>
                      Key persons in your organization/team
                    </InputLabel>
                  </div>
                </StyledTableCell>
              </TableRowHead>
              <TableRowHead>
                <StyledTableCell colSpan={3} align="center">
                  <InputLabel>Name</InputLabel>
                </StyledTableCell>
                <StyledTableCell colSpan={3} align="center">
                  <InputLabel>Title</InputLabel>
                </StyledTableCell>
              </TableRowHead>
              {Organizationteam.map((organizationteam, index) => {
                if (!organizationteam.Status) return null;
                return (
                  <TableRow key={index}>
                    <StyledTableCell colSpan={3}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name={`organizationteam[${index}].organizationName`}
                            value={
                              formik.values.organizationteam[index]
                                ?.organizationName || null
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `organizationteam[${index}].organizationName`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `organizationteam[${index}].organizationName`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell colSpan={2}>
                      <div className={classes.cellContent}>
                        <div className={classes.wrapField}>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            name={`organizationteam[${index}].OrganizationTitle`}
                            value={
                              formik.values.organizationteam[index]
                                ?.OrganizationTitle || null
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={isError(
                              `organizationteam[${index}].OrganizationTitle`,
                              formik
                            )}
                            helperText={getErrorMessage(
                              `organizationteam[${index}].OrganizationTitle`,
                              formik
                            )}
                          />
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell style={{ width: 40 }}>
                      {index === 0 ? (
                        <div style={{ width: 40 }} />
                      ) : (
                        <>
                          <IconButton
                            disabled={!canEdit}
                            style={{
                              width: 40,
                              color: theme.palette.error.main,
                            }}
                            size="small"
                            onClick={async () => {
                              if (organizationteam.organizationId) {
                                formik.setFieldValue(
                                  `organizationteam[${index}].Status`,
                                  false
                                );
                              } else {
                                formik.setFieldValue(
                                  "organizationteam",
                                  Organizationteam.filter(
                                    (__, i) => i !== index
                                  )
                                );
                              }
                            }}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                          <FormHelperText error={false}> </FormHelperText>
                        </>
                      )}
                    </StyledTableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <StyledTableCell colSpan={6}>
                  <div className={classes.flexRow}>
                    <AddRowButton
                      disabled={!canEdit}
                      onClick={() => {
                        formik.setFieldValue("organizationteam", [
                          ...Organizationteam,
                          mapOrganizationteam(defaultOrganizationteam),
                        ]);
                      }}
                    />
                  </div>
                </StyledTableCell>
              </TableRow>

              {configField2.map((field) => (
                <TableRow key={field.fieldName}>
                  <StyledTableCell colSpan={6}>
                    <div className={classes.cellContent}>
                      <Bagde number={field.bagde} />
                      <div className={classes.wrapField}>
                        <InputLabel>{field.label}</InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={field.fieldName}
                          value={formik.values[field.fieldName]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError(field.fieldName, formik)}
                          helperText={getErrorMessage(field.fieldName, formik)}
                          multiline
                          rows={5}
                          rowsMin={5}
                          rowsMax={5}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.HEALTH_INSUANCE));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
